export default "__VITE_ASSET__G016kTUy__"